import { render, staticRenderFns } from "./PaymentQRCard.vue?vue&type=template&id=1c228088&scoped=true&"
import script from "./PaymentQRCard.vue?vue&type=script&lang=js&"
export * from "./PaymentQRCard.vue?vue&type=script&lang=js&"
import style0 from "./PaymentQRCard.vue?vue&type=style&index=0&id=1c228088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c228088",
  null
  
)

export default component.exports